import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage'
import "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyDYg9b8SqqAHVmqIEPDZnApH5oyd4yCFFU",
  authDomain: "berhampore-lodge-9e8f0.firebaseapp.com",
  projectId: "berhampore-lodge-9e8f0",
  storageBucket: "berhampore-lodge-9e8f0.firebasestorage.app",
  messagingSenderId: "113246349852",
  appId: "1:113246349852:web:8b6979d858b886fc660dd9",
  measurementId: "G-45HWTDYYLF"
};
//init firebase app
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const db = getFirestore(app);




export default app;


